import React,{ useRef } from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Tooltip,Avatar,Modal,Form,Switch,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,PlusOutlined,LoadingOutlined,DownloadOutlined,DownOutlined,UpOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import { ReportEmailControls, submitReportWithEmail, reportSearchButtonLabel, REPORT_KEYS, initialReportEmailState } from '../reportEmailUtils';
import { LedgerJournalInfoAlert, TrialBalanceBreakdown, incomeStatementAccountKey } from '../journalReportUtils';
import * as reactstrp from 'reactstrap';

import {
  Col,
  Row,
} from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import '../tablestyle.css';

const INCOME_STATEMENT_COLUMN_COUNT = 6;


var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


var token= ''
var sacco= ''
var bizuserid= ''


class ReportToPrint extends React.Component {

    state = {
    ...initialReportEmailState(),
      companyprofile:{}
    };
  
    componentDidMount(){
      if(localStorage.getItem("sacco")){
         sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
         bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
      
      }else{
         sacco= ''
         bizuserid= ''
      }
      
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }


      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
      .then(res => {  
          this.setState({
            companyprofile: res.data
          })
  
      })
  
    }



  //calculate totals
  calculateTotalcredit_incomes=()=>{
    var total =0

    this.props.incomes.map((item)=>{
      total+=Number(item.credit)
    })

    return total.toFixed(2)
  }

  calculateTotaldebit_incomes=()=>{
    var total =0

    this.props.incomes.map((item)=>{
      total+=Number(item.debit)
    })

    return total.toFixed(2)
  }

  calculateTotalbalance_incomes=()=>{
    var total =0

    this.props.incomes.map((item)=>{
      total+=Number(item.balance)
    })

    return total.toFixed(2)
  }



  calculateTotalcredit_expenses=()=>{
    var total =0

    this.props.expenses.map((item)=>{
      total+=Number(item.credit)
    })

    return total.toFixed(2)
  }

  calculateTotaldebit_expenses=()=>{
    var total =0

    this.props.expenses.map((item)=>{
      total+=Number(item.debit)
    })

    return total.toFixed(2)
  }

  calculateTotalBalance_expenses=()=>{
    var total =0

    this.props.expenses.map((item)=>{
      total+=Number(item.balance)
    })

    return total.toFixed(2)
  }



  //calculate surplus
  CalculateSurplus=()=>{
    var total=0

    total=this.calculateTotalbalance_incomes()-this.calculateTotalBalance_expenses()

    return total.toFixed(2)
  }


  
    render() {
      return (
        <div style={{padding:20}}>
      <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h5>{this.state.companyprofile.companydealership}</h5>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
              
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>

                  </Col>

           </Row>

             <h3 style={{display: 'flex',justifyContent:'center', alignItems:'center',fontWeight:'bolder'}}>INCOME STATEMENT FROM: {this.props.dateone}  TO: {this.props.datetwo}</h3>

             <h4>INCOMES </h4>
            <reactstrp.Table bordered>
                      <thead>
                        <tr>
                        <th>No</th>
                          <th>Account</th>
                         {/* {this.props.view_opening_balance? <th>Opening Balance</th>:null} */}
                          <th>Debit</th>
                          <th>Credit</th>
                          <th>Balance</th>

                        </tr>
                      </thead>
                      <tbody>
                      {this.props.incomes.map(
                        (item)=>(
                          <tr>
                          <td>{item.no}</td>
                          <td>{item.account}</td>
                            {/* {this.props.view_opening_balance?<td className="align-right">{<CurrencyFormat value={item.total_inst_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null} */}
                          <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.balance} displayType={'text'} thousandSeparator={true}/>}</td>

                          </tr>
                        ))}
                        <tr>
                        <td>Total</td>
                        <td></td>
                            {/* {this.props.view_opening_balance?<td></td>:null} */}

                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotaldebit_incomes()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalcredit_incomes()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalbalance_incomes()} displayType={'text'} thousandSeparator={true}/>}</td>

                        </tr>

                    </tbody>
                </reactstrp.Table>   

            <br></br> 
            <Divider style={{borderColor:'red'}} dashed />
            <h4>EXPENSES</h4>

            <reactstrp.Table bordered>
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Account</th>
                          {/* {this.props.view_opening_balance?<th>Opening Balance</th>:null} */}
                          <th>Debit</th>
                          <th>Credit</th>
                          <th>Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                      {this.props.expenses.map(
                        (item)=>(
                          <tr>
                          <td>{item.no}</td>

                          <td>{item.account}</td>
                          {/* {this.props.view_opening_balance?<td className="align-right">{<CurrencyFormat value={item.total_inst_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null} */}
                          <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.balance} displayType={'text'} thousandSeparator={true}/>}</td>

                          </tr>
                        ))}
                        <tr>
                        <td>Total</td>
                        <td></td>
                        {/* {this.props.view_opening_balance?<td></td>:null} */}

                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotaldebit_expenses()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalcredit_expenses()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalBalance_expenses()} displayType={'text'} thousandSeparator={true}/>}</td>

                        </tr>

                    </tbody>
                </reactstrp.Table> 

                <br></br> 
              <Divider style={{borderColor:'red'}} dashed />
              <h4>SURPLUS</h4>
              <reactstrp.Table bordered>
                      <thead>
                      <tr>
                        <td>Surplus</td>
                        <th></th>
                        {/* {this.props.view_opening_balance?<th></th>:null} */}
                        <th></th>

                        <td className="align-right"style={{fontWeight:'bolder'}}></td>
                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.CalculateSurplus()} displayType={'text'} thousandSeparator={true}/>}</td>
                        </tr>
                      </thead>
                      
                </reactstrp.Table> 
        </div>
      );
    }
  }


class IncomeStatementReport extends React.Component {

  state = {
   ...initialReportEmailState(),
   expenses:[],
   incomes:[],
   dateone:'',
   datetwo:'',
   totalincomes:0,
   totalexpenses:0,
   surplus:0,
   datarequested:false,
   companyprofile: {},

   expandedAccountKey: null,
   breakdownLoadingKey: null,
   reportBasis: '',

  };

  accountRowKey = (section, item) => incomeStatementAccountKey(section, item);

  parseStatementRows = (rows) => (rows || []).map((row) => ({
    ...row,
    breakdown: row.breakdown || [],
    breakdownLoaded: false,
    breakdownSummary: null,
    breakdownError: null,
  }));

  loadAccountBreakdown = (item, section) => {
    if (!item || item.breakdownLoaded) {
      return;
    }
    const rowKey = this.accountRowKey(section, item);
    this.setState({ breakdownLoadingKey: rowKey });
    const form_data = new FormData();
    form_data.append('sacco', sacco);
    form_data.append('account', item.account);
    form_data.append('dateone', this.state.dateone);
    form_data.append('datetwo', this.state.datetwo);
    axios.post(
      serverconfig.backendserverurl + '/customqueries/getIncomeStatementBreakdown',
      form_data,
      { timeout: 120000 }
    )
      .then((res) => {
        const breakdown = res.data.breakdown || [];
        const breakdownError = res.data.error_detail || null;
        const breakdownSummary = {
          trial_balance_debit: res.data.statement_debit,
          trial_balance_credit: res.data.statement_credit,
          statement_balance: res.data.statement_balance,
          total_debit: res.data.period_debit_total,
          total_credit: res.data.period_credit_total,
        };
        const stateKey = section === 'income' ? 'incomes' : 'expenses';
        const merge = (list) =>
          list.map((row) =>
            this.accountRowKey(section, row) === rowKey
              ? { ...row, breakdown, breakdownLoaded: true, breakdownSummary, breakdownError }
              : row
          );
        this.setState({
          [stateKey]: merge(this.state[stateKey]),
          reportBasis: res.data.report_basis || '',
          breakdownLoadingKey: null,
        });
      })
      .catch((err) => {
        console.log(err);
        message.error('Failed to load GL breakdown for this account');
        this.setState({ breakdownLoadingKey: null });
      });
  };

  toggleAccountBreakdown = (item, section) => {
    const rowKey = this.accountRowKey(section, item);
    if (this.state.expandedAccountKey === rowKey) {
      this.setState({ expandedAccountKey: null });
      return;
    }
    this.setState({ expandedAccountKey: rowKey });
    if (!item.breakdownLoaded) {
      this.loadAccountBreakdown(item, section);
    }
  };

  renderStatementRows = (section, items, totalDebit, totalCredit, totalBalance) => (
    <>
      {(items || []).map((item) => {
        const rowKey = this.accountRowKey(section, item);
        return (
          <React.Fragment key={rowKey}>
            <tr>
              <td>
                <Button
                  type="link"
                  size="small"
                  loading={this.state.breakdownLoadingKey === rowKey}
                  icon={this.state.expandedAccountKey === rowKey ? <UpOutlined /> : <DownOutlined />}
                  onClick={() => this.toggleAccountBreakdown(item, section)}
                >
                  {this.state.expandedAccountKey === rowKey ? 'Hide' : 'Show'}
                </Button>
              </td>
              <td>{item.no}</td>
              <td>{item.account}</td>
              <td className="align-right">
                <CurrencyFormat value={item.debit} displayType="text" thousandSeparator />
              </td>
              <td className="align-right">
                <CurrencyFormat value={item.credit} displayType="text" thousandSeparator />
              </td>
              <td className="align-right">
                <CurrencyFormat value={item.balance} displayType="text" thousandSeparator />
              </td>
            </tr>
            {this.state.expandedAccountKey === rowKey ? (
              <tr>
                <td colSpan={INCOME_STATEMENT_COLUMN_COUNT}>
                  {this.state.breakdownLoadingKey === rowKey ? (
                    <div style={{ padding: 24, textAlign: 'center' }}>
                      <Spin />
                    </div>
                  ) : (
                    <TrialBalanceBreakdown
                      breakdown={item.breakdown}
                      reportBasis={this.state.reportBasis}
                      summary={item.breakdownSummary}
                      errorDetail={item.breakdownError}
                      basisTitle="How the income statement figure is built"
                      summaryLabel="Statement line"
                      balanceLabel="Balance"
                    />
                  )}
                </td>
              </tr>
            ) : null}
          </React.Fragment>
        );
      })}
      <tr>
        <td colSpan={3} style={{ fontWeight: 'bolder' }}>Total</td>
        <td className="align-right" style={{ fontWeight: 'bolder' }}>
          <CurrencyFormat value={totalDebit} displayType="text" thousandSeparator />
        </td>
        <td className="align-right" style={{ fontWeight: 'bolder' }}>
          <CurrencyFormat value={totalCredit} displayType="text" thousandSeparator />
        </td>
        <td className="align-right" style={{ fontWeight: 'bolder' }}>
          <CurrencyFormat value={totalBalance} displayType="text" thousandSeparator />
        </td>
      </tr>
    </>
  );

  componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    
    }else{
        sacco= ''
        bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {
      this.setState((prev) => ({
        companyprofile: res.data,
        receiving_email: prev.receiving_email || res.data.company_email || '',
      }));
    });

  }

  handledatechange= (date, dateString) =>{
    this.setState({ dateone: dateString[0]});
    this.setState({ datetwo: dateString[1]});
  } 

  //calculate totals
  calculateTotalcredit_incomes=()=>{
    var total =0

    this.state.incomes.map((item)=>{
      total+=Number(item.credit)
    })

    return total.toFixed(2)
  }

  calculateTotaldebit_incomes=()=>{
    var total =0

    this.state.incomes.map((item)=>{
      total+=Number(item.debit)
    })

    return total.toFixed(2)
  }


  calculateTotalbalance_incomes=()=>{
    var total =0

    this.state.incomes.map((item)=>{
      total+=Number(item.balance)
    })

    return total.toFixed(2)
  }



  calculateTotalcredit_expenses=()=>{
    var total =0

    this.state.expenses.map((item)=>{
      total+=Number(item.credit)
    })

    return total.toFixed(2)
  }

  calculateTotaldebit_expenses=()=>{
    var total =0

    this.state.expenses.map((item)=>{
      total+=Number(item.debit)
    })

    return total.toFixed(2)
  }


  calculateTotalBalance_expenses=()=>{
    var total =0

    this.state.expenses.map((item)=>{
      total+=Number(item.balance)
    })

    return total.toFixed(2)
  }


  //calculate surplus
  CalculateSurplus=()=>{
    var total=0

    total=this.calculateTotalbalance_incomes()-this.calculateTotalBalance_expenses()

    return total.toFixed(2)
  }




  //search incomes method
  getstatement=()=>{
   if(this.state.dateone===''||this.state.datetwo===''){
    alert("Please are dates missing")
    return;
   }

   let form_data = new FormData();
    form_data.append('dateone', this.state.dateone);
    form_data.append('datetwo', this.state.datetwo);
    form_data.append('sacco', sacco);

    submitReportWithEmail({
      reportKey: REPORT_KEYS.INCOME_STATEMENT,
      params: { dateone: this.state.dateone, datetwo: this.state.datetwo, sacco },
      emailReport: this.state.email_report,
      receivingEmail: this.state.receiving_email,
      endpoint: serverconfig.backendserverurl + '/customqueries/getincomestatement',
      formData: form_data,
      setLoading: (v) => this.setState({
        datarequested: v,
        ...(v ? { expandedAccountKey: null, reportBasis: '' } : {}),
      }),
      onSuccess: (res) => {
        this.setState({
          expenses: this.parseStatementRows(JSON.parse(res.data.pandl_list_expense)),
          incomes: this.parseStatementRows(JSON.parse(res.data.pandl_list_incomes)),
        });
      },
      useInlineEmail: true,
    });
   }



  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {
      
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>
          <LedgerJournalInfoAlert />
          <div style={{display: "none"}}>
             &nbsp;&nbsp;
            <ReportToPrint
            dateone={this.state.dateone}
            datetwo={this.state.datetwo}
            incomes={this.state.incomes}
            expenses={this.state.expenses}
            ref={el => (this.componentRef = el)} 
            
            // view_opening_balance={this.state.view_opening_balance}
            
            /> 

          </div>

          <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header="INCOME STATEMENT" key="1">


            <div style={{display:'flex',justifyContent:'flex-start',alignSelf:'flex-start',alignItems:'flex-start'}}>

              {!this.state.email_report ? (
              <>
              <ReactToPrint
              trigger={() => 
              <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
              Print
              </Button>
              }
              content={() => this.componentRef}
              />
              &nbsp;&nbsp;
              <ExcelFile filename={"Pisacco - Incomestatement report from "+this.state.dateone+" to "+this.state.datetwo}   element={<Button type='primary' icon={<DownloadOutlined/>}>Download report (Excel)</Button>}>
                <ExcelSheet data={this.state.incomes} name="Incomes">
                    <ExcelColumn label="No" value="no"/>
                    <ExcelColumn label="Account" value="account"/>
                    {/* <ExcelColumn label="Opening Balance" value="total_inst_balance"/> */}

                    <ExcelColumn label="Debit" value="debit"/>
                    <ExcelColumn label="Credit" value="credit"/>
                    <ExcelColumn label="Balance" value="balance"/>

                </ExcelSheet>

                <ExcelSheet data={this.state.expenses} name="Expenses">
                    <ExcelColumn label="No" value="no"/>
                    <ExcelColumn label="Account" value="account"/>
                    {/* <ExcelColumn label="Opening Balance" value="total_inst_balance"/> */}
                    <ExcelColumn label="Debit" value="debit"/>
                    <ExcelColumn label="Credit" value="credit"/>
                    <ExcelColumn label="Balance" value="balance"/>

                </ExcelSheet>
            </ExcelFile>
            &nbsp;&nbsp;
              </>
              ) : null}

              <Form  layout="inline" >
                  <FormItem label="Date Range">
                      <RangePicker defaultValue={moment()} onChange={this.handledatechange} format={dateFormat} />
                  </FormItem>

                {/* <FormItem label="Show Opening Balances">
                  <Switch
                    checked={this.state.view_opening_balance}
                    onChange={val=>{this.setState({view_opening_balance:val})}}
                    checkedChildren="True"
                    unCheckedChildren="False"
                    />
                </FormItem> */}

                  <ReportEmailControls
                    emailReport={this.state.email_report}
                    receivingEmail={this.state.receiving_email}
                    onEmailReportChange={(val) => this.setState({ email_report: val })}
                    onReceivingEmailChange={(val) => this.setState({ receiving_email: val })}
                    companyEmail={this.state.companyprofile.company_email}
                  />

                  <FormItem>
                  <Button onClick={this.getstatement} type="primary" htmlType="button">{reportSearchButtonLabel(this.state.email_report)}</Button>
                  </FormItem> 

              </Form>

              </div>


           <br></br>
           <h4>INCOMES </h4>
            <reactstrp.Table bordered>
                      <thead>
                        <tr>
                           <th>Breakdown</th>
                           <th>No</th>
                          <th>Account</th>
                          <th>Debit</th>
                          <th>Credit</th>
                          <th>Balance</th>

                        </tr>
                      </thead>
                      <tbody>
                      {this.renderStatementRows(
                        'income',
                        this.state.incomes,
                        this.calculateTotaldebit_incomes(),
                        this.calculateTotalcredit_incomes(),
                        this.calculateTotalbalance_incomes()
                      )}
                    </tbody>
                </reactstrp.Table>   

            <br></br> 
            <Divider style={{borderColor:'red'}} dashed />
            <h4>EXPENSES</h4>

            <reactstrp.Table bordered>
                      <thead>
                        <tr>
                          <th>Breakdown</th>
                          <th>No</th>
                          <th>Account</th>
                          <th>Debit</th>
                          <th>Credit</th>
                          <th>Balance</th>

                        </tr>
                      </thead>
                      <tbody>
                      {this.renderStatementRows(
                        'expense',
                        this.state.expenses,
                        this.calculateTotaldebit_expenses(),
                        this.calculateTotalcredit_expenses(),
                        this.calculateTotalBalance_expenses()
                      )}
                    </tbody>
                </reactstrp.Table> 

                <br></br> 
              <Divider style={{borderColor:'red'}} dashed />

                        {
                          this.CalculateSurplus()>0?
                          <div>
                            <h4>SURPLUS</h4>
                          <reactstrp.Table bordered>
                                  <thead>
                                  <tr>
                                    <td>Surplus</td>
                                    <td></td>
                                    {/* {this.state.view_opening_balance?<td></td>:null} */}
                                    <td></td>

                                    <td className="align-right"style={{fontWeight:'bolder'}}></td>
                                    <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.CalculateSurplus()} displayType={'text'} thousandSeparator={true}/>}</td>
                                    </tr>
                                  </thead>
                                  
                            </reactstrp.Table> 
                          </div>
                        
            
                          :
                          <div>

                          <h4>DEFICIT</h4>
                          <reactstrp.Table bordered>
                                  <thead>
                                  <tr>
                                    <td>Surplus</td>
                                    <td></td>
                                    {/* {this.state.view_opening_balance?<td></td>:null} */}
                                    <td></td>
            
                                    <td className="align-right"style={{fontWeight:'bolder'}}></td>
                                    <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.CalculateSurplus()} displayType={'text'} thousandSeparator={true}/>}</td>
                                    </tr>
                                  </thead>
                                  
                            </reactstrp.Table> 
                          </div>
                          
            
                        }


        </Panel>
        </Collapse>

        </div>
    )}
    
  }
}

export default IncomeStatementReport; 
